import React from 'react';
import { useThemeColors } from '../../hooks/useThemeColors';

const Button = ({ 
  onClick, 
  color = 'blue', 
  children, 
  disabled = false, 
  type = 'button',
  loading = false,
  className = '',
  size = 'md'
}) => {
  const { buttonColors } = useThemeColors();
  // Base classes
  const baseClasses = "inline-flex items-center justify-center font-medium rounded-md focus:outline-none";
  
  // Size classes
  const sizeClasses = {
    sm: "px-3 py-1.5 text-xs",
    md: "px-4 py-2 text-sm",
    lg: "px-5 py-2.5 text-base"
  };
  
  // Color classes with dynamic theme support
  const getColorStyle = (colorName) => {
    if (colorName === 'blue') {
      return {
        backgroundColor: buttonColors.primary,
        color: 'white',
        boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
      };
    }
    return null;
  };

  const colorClasses = {
    blue: "text-white shadow-sm transition-colors",
    red: "bg-red-600 hover:bg-red-700 text-white shadow-sm",
    gray: "bg-gray-100 hover:bg-gray-200 text-gray-800",
    green: "bg-green-600 hover:bg-green-700 text-white shadow-sm",
    transparent: "bg-transparent hover:bg-gray-100 text-gray-600"
  };
  
  // Disabled classes
  const disabledClasses = "opacity-50 cursor-not-allowed";
  
  // Combine classes
  const buttonClasses = `
    ${baseClasses} 
    ${sizeClasses[size]} 
    ${colorClasses[color]} 
    ${disabled || loading ? disabledClasses : ''}
    ${className}
  `;
  
  const dynamicStyle = getColorStyle(color);

  return (
    <button
      type={type}
      className={buttonClasses}
      style={dynamicStyle}
      onMouseEnter={(e) => {
        if (color === 'blue' && !disabled && !loading) {
          e.target.style.backgroundColor = buttonColors.primaryHover;
        }
      }}
      onMouseLeave={(e) => {
        if (color === 'blue' && !disabled && !loading) {
          e.target.style.backgroundColor = buttonColors.primary;
        }
      }}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading && (
        <svg 
          className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" 
          xmlns="http://www.w3.org/2000/svg" 
          fill="none" 
          viewBox="0 0 24 24"
        >
          <circle 
            className="opacity-25" 
            cx="12" 
            cy="12" 
            r="10" 
            stroke="currentColor" 
            strokeWidth="4"
          ></circle>
          <path 
            className="opacity-75" 
            fill="currentColor" 
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}
      {children}
    </button>
  );
};

export default Button; 